<template>
  <div class="settings-show-bet-in">
    <div
      v-if="hasTitle"
      class="d-flex"
    >
      <GwTitleTooltip
        class="theme-block-title"
        :title="$t('settings.show_ev_icm_in')"
      />
      <div
        class="gw_btn ml-1 z-index_0 gw_btn_small clr-grey text-small f-justify-start bt-grey"
        style="--padding: 0.5rem"
        @click="$store.dispatch('router_set_dialogs', 'ev-converter-help-dialog')"
      >
        {{ $t('common.how_it_works') }}
      </div>
    </div>
    <div
      v-if="hasOptions"
      class="d-flex"
    >
      <GwBtns
        :options="options"
        :value="showEvIcmIn"
        idKey="payload"
        class="gwbtns_horizontal_grey"
        style="
          background: var(--clr-black-1-3);
          border-radius: 4px;
          --gwbtn-size: 1rem;
          --gwbtn-height: 1.875rem;
          --gwbtns-wrap: wrap;
          --gwbtns-padding: 2px;
        "
        @click="
          (_e, item) => {
            showEvIcmIn = item.payload
          }
        "
      >
        <template #default="{ item }">
          {{ $t(`units.ev.${item.payload}`) }}
        </template>
      </GwBtns>
    </div>

    <div
      v-if="hasKey"
      class="text-smallest text-grey ml-1 mt-2"
      v-html="
        $t('common.press_hotkey_to_switch', {
          key: hotkeys.switch_ev_pot.displayCombination,
        })
      "
    ></div>
    <div
      v-if="hasPreview"
      class="ursetappr_preview"
      :class="{ 'mt-2': hasOptions }"
    >
      <div
        class="d-flex mr-auto uppercase weight_700 ml-1 z-index_3 position-relative"
        v-html="
          getEvHtml({
            ev: 0.2,
            pot: 12,
            showEvIcmIn,
          })
        "
      ></div>
    </div>
  </div>
</template>

<script>
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import GwBtns from '@/components/lib/GwBtns'
import { allSwitchers } from '@/store/switchers/switchers'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SettingsEvIcmIn',
  components: {
    GwTitleTooltip,
    GwBtns,
  },
  mixins: [format_mix],
  props: {
    hasTitle: { type: Boolean, default: true },
    hasOptions: { type: Boolean, default: true },
    hasPreview: { type: Boolean, default: true },
    hasKey: { type: Boolean, default: true },
  },
  data() {
    return {
      options: allSwitchers().sw_ev_icm_converter,
    }
  },
  methods: {
    reset() {
      this.value = 'bb'
    },
  },
  computed: {
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    showEvIcmIn: {
      get() {
        return this.$store.getters.sw_ev_icm_converter
      },
      set(value) {
        this.$store.dispatch('userSettings', { showEvIcmIn: value })
      },
    },
  },
}
</script>

<style lang="scss">
.settings-show-bet-in {
  flex-direction: column;
  display: flex;
  flex-shrink: 0;
}
</style>
